import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/reviews";

export const reviewsApi = {
  createEmployerReview: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/employer`, body),

  listEmployerReviews: (organizationId: string, params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/employer/${organizationId}?${searchParams.toString()}`);
  },

  listAllEmployerReviews: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/employers?${searchParams.toString()}`);
  },

  getEmployerReview: (id: string) => apiGet<{ data: Record<string, unknown> }>(`${BASE}/employer/detail/${id}`),

  updateEmployerReview: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`${BASE}/employer/${id}`, body),

  deleteEmployerReview: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`${BASE}/employer/${id}`),

  createVendorListing: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/vendors`, body),

  listVendors: (params?: PaginatedParams & { category?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.category) searchParams.set("category", params.category);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/vendors?${searchParams.toString()}`);
  },

  getVendor: (id: string) => apiGet<{ data: Record<string, unknown> }>(`${BASE}/vendors/${id}`),

  createVendorReview: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/vendor-reviews`, body),

  listVendorReviews: (vendorId: string, params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/vendor-reviews/${vendorId}?${searchParams.toString()}`);
  },

  createSalaryBenchmark: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/salary`, body),

  listSalaryBenchmarks: (params?: PaginatedParams & { jobTitle?: string; location?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.jobTitle) searchParams.set("jobTitle", params.jobTitle);
    if (params?.location) searchParams.set("location", params.location);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/salary?${searchParams.toString()}`);
  },
};